import styled, { css } from 'styled-components';
import { gridSizes, media } from 'utils/style';

import CreditCard from 'pages/CreditCard/component';

const mainStyles = css`
  flex-direction: 'row';
  max-width: 540px;
  align-items: stretch;
  min-height: 100%;
  /* align-items: baseline; */
  margin: 64px auto;

  ${media.lessThan('small')`
    max-width: calc(100vw - 60px);
    padding: ${gridSizes('S')};
  `};

  ${media.lessThan('extraSmall')`
    max-width: 100%;
    margin: 0;
  `};
`;

export default styled(CreditCard)`
  .main {
    ${mainStyles};
  }
`;
